import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "dynamic-content" }
const _hoisted_2 = {
  key: 0,
  class: "dynamic-loading"
}
const _hoisted_3 = {
  key: 1,
  class: "dynamic-error"
}
const _hoisted_4 = {
  key: 2,
  class: "component-container"
}
const _hoisted_5 = {
  key: 3,
  class: "component-container"
}
const _hoisted_6 = {
  key: 4,
  class: "component-container"
}
const _hoisted_7 = {
  key: 5,
  class: "component-container"
}
const _hoisted_8 = {
  key: 6,
  class: "component-container"
}
const _hoisted_9 = {
  key: 7,
  class: "component-container"
}
const _hoisted_10 = {
  key: 8,
  class: "component-container"
}
const _hoisted_11 = {
  key: 9,
  class: "component-container"
}
const _hoisted_12 = {
  key: 10,
  class: "component-container"
}
const _hoisted_13 = {
  key: 11,
  class: "component-container"
}
const _hoisted_14 = {
  key: 12,
  class: "component-container"
}
const _hoisted_15 = {
  key: 13,
  class: "component-container"
}
const _hoisted_16 = {
  key: 14,
  class: "component-container"
}
const _hoisted_17 = {
  key: 15,
  class: "component-container"
}
const _hoisted_18 = {
  key: 16,
  class: "component-container"
}
const _hoisted_19 = {
  key: 17,
  class: "component-container empty-component"
}
const _hoisted_20 = { class: "empty-text" }

import { ref } from 'vue';
import { PhotoGallery, ProjectDocuments, ProjectDesign, ProjectFinance, ProjectAccess, ProjectNotifications, DeliveryIssues, ProjectAuditTrail } from './index';
import BudgetConsumptionReport from './reports/BudgetConsumptionReport.vue';
import ProjectNotes from './notes/ProjectNotes.vue';
import ProjectWorkspace from './workspace/ProjectWorkspace.vue';
import ProjectPlanning from './planning/ProjectPlanning.vue';

interface Props {
  componentName: string;
  projectId: number | string | null;
  project?: any; // Project data from parent to avoid redundant API calls
}

interface Emits {
  (e: 'retry'): void;
  (e: 'return-to-project'): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DynamicContent',
  props: {
    componentName: { default: '' },
    projectId: { default: null },
    project: { default: null }
  },
  emits: ["retry", "return-to-project"],
  setup(__props: any, { emit: __emit }) {

/// <reference types="vue" />
// @ts-ignore
const props = __props;

const emit = __emit;

const loading = ref<boolean>(false);
const error = ref<string | null>(null);

// In a real implementation, we would load data based on the component name
// For example:
/*
const loadData = async () => {
  if (!props.componentName || !props.projectId) return;

  loading.value = true;
  error.value = null;

  try {
    // Example API call based on component type
    let data;
    switch (props.componentName) {
      case 'tasks':
        data = await ProjectService.getProjectTasks(props.projectId);
        break;
      case 'photos':
        data = await ProjectService.getProjectPhotos(props.projectId);
        break;
      // And so on for other component types
      default:
        data = null;
    }

    hasContent.value = data && (Array.isArray(data) ? data.length > 0 : true);
  } catch (err) {
    console.error('Error loading component data:', err);
    error.value = err.message;
  } finally {
    loading.value = false;
  }
};

// Watch for changes to load data when component or project changes
watch(
  () => [props.componentName, props.projectId],
  () => {
    if (props.componentName && props.projectId) {
      loadData();
    }
  },
  { immediate: true }
);
*/

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "loading-spinner" }, null, -1)),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('common.loading')), 1)
        ]))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("p", null, _toDisplayString(error.value), 1),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('retry'))),
              class: "btn btn-secondary"
            }, _toDisplayString(_ctx.$t('common.retry')), 1)
          ]))
        : (_ctx.componentName === 'tasks')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(ProjectWorkspace, {
                projectId: _ctx.projectId,
                initialProject: _ctx.project,
                onReturnToProject: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('return-to-project'))),
                defaultActiveTab: "tasks"
              }, null, 8, ["projectId", "initialProject"])
            ]))
          : (_ctx.componentName === 'phases')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(ProjectWorkspace, {
                  projectId: _ctx.projectId,
                  initialProject: _ctx.project,
                  onReturnToProject: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('return-to-project'))),
                  defaultActiveTab: "phases"
                }, null, 8, ["projectId", "initialProject"])
              ]))
            : (_ctx.componentName === 'workspace')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(ProjectWorkspace, {
                    projectId: _ctx.projectId,
                    initialProject: _ctx.project,
                    onReturnToProject: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('return-to-project')))
                  }, null, 8, ["projectId", "initialProject"])
                ]))
              : (_ctx.componentName === 'photos')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_unref(PhotoGallery), { projectId: _ctx.projectId }, null, 8, ["projectId"])
                  ]))
                : (_ctx.componentName === 'documents')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_unref(ProjectDocuments), {
                        projectId: _ctx.projectId,
                        onReturnToProject: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('return-to-project')))
                      }, null, 8, ["projectId"])
                    ]))
                  : (_ctx.componentName === 'design')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(_unref(ProjectDesign), {
                          projectId: _ctx.projectId,
                          onReturnToProject: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('return-to-project')))
                        }, null, 8, ["projectId"])
                      ]))
                    : (_ctx.componentName === 'budget')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createVNode(_unref(ProjectFinance), {
                            projectId: _ctx.projectId,
                            onReturnToProject: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('return-to-project')))
                          }, null, 8, ["projectId"])
                        ]))
                      : (_ctx.componentName === 'issues')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createVNode(_unref(DeliveryIssues), { "project-id": _ctx.projectId }, null, 8, ["project-id"])
                          ]))
                        : (_ctx.componentName === 'intervenants')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _createVNode(ProjectWorkspace, {
                                projectId: _ctx.projectId,
                                initialProject: _ctx.project,
                                onReturnToProject: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('return-to-project'))),
                                defaultActiveTab: "intervenants"
                              }, null, 8, ["projectId", "initialProject"])
                            ]))
                          : (_ctx.componentName === 'notes')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createVNode(ProjectNotes, {
                                  projectId: _ctx.projectId,
                                  onReturnToProject: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('return-to-project')))
                                }, null, 8, ["projectId"])
                              ]))
                            : (_ctx.componentName === 'access')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  _createVNode(_unref(ProjectAccess), {
                                    projectId: _ctx.projectId,
                                    onReturnToProject: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('return-to-project')))
                                  }, null, 8, ["projectId"])
                                ]))
                              : (_ctx.componentName === 'notifications')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    _createVNode(_unref(ProjectNotifications), {
                                      projectId: _ctx.projectId,
                                      onReturnToProject: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('return-to-project')))
                                    }, null, 8, ["projectId"])
                                  ]))
                                : (_ctx.componentName === 'report')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                      _createVNode(BudgetConsumptionReport, { projectId: _ctx.projectId }, null, 8, ["projectId"])
                                    ]))
                                  : (_ctx.componentName === 'audit')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                        _createVNode(_unref(ProjectAuditTrail), {
                                          projectId: _ctx.projectId,
                                          onReturnToProject: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('return-to-project')))
                                        }, null, 8, ["projectId"])
                                      ]))
                                    : (_ctx.componentName === 'planning')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                          _createVNode(ProjectPlanning, {
                                            projectId: _ctx.projectId,
                                            project: _ctx.project
                                          }, null, 8, ["projectId", "project"])
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                          _cache[13] || (_cache[13] = _createElementVNode("svg", {
                                            viewBox: "0 0 24 24",
                                            width: "80",
                                            height: "80"
                                          }, [
                                            _createElementVNode("path", {
                                              fill: "var(--neutral-300)",
                                              d: "M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"
                                            })
                                          ], -1)),
                                          _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t('projects.selectAction')), 1)
                                        ]))
  ]))
}
}

})